import { render, staticRenderFns } from "./DevTables2.vue?vue&type=template&id=0ce17774&scoped=true"
import script from "./DevTables2.vue?vue&type=script&lang=js"
export * from "./DevTables2.vue?vue&type=script&lang=js"
import style0 from "./DevTables2.vue?vue&type=style&index=0&id=0ce17774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce17774",
  null
  
)

export default component.exports